// Components
import { Button, Form, Input } from "antd";
import { Head } from "components/molecules/Head/Head";
import LoginWrapper from "components/molecules/Login/Login";
import UpdateWatchword from "containers/UpdateWatchword/UpdateWatchword";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";

// utils
import getIcon, { IconProps } from "utils/getIcon";

// styles
import styles from "containers/ForgotWatchword/forgotWatchword.module.css";

// Constants
import { ForgotWatchword as Constants, PageTitles } from "constants/global";

// hooks
import { useForgotWatchword, ForgotWatchwordTypes } from "containers/ForgotWatchword/useForgotWatchword";

const Icon = (props: IconProps) => getIcon({ ...props });

const ForgotWatchword = () => {
	const [form] = Form.useForm();

	const componentProps: ForgotWatchwordTypes = useForgotWatchword();

	const {
		showUpdateWatchword,
		isValidUsername,
		updateWatchwordProps,
		showingModal,
		username,
		showForceChangeWatchwordDisclaimer,
		onUsernameChange,
		initiateForgotWatchword,
		handleGoBack
	} = componentProps;

	const usernameValidCls = isValidUsername === "valid" ? styles?.filled : "";
	const usernameInvalidCls = isValidUsername === "invalid" ? styles?.err : "";

	if (showingModal) {
		return <div className={styles?.root}></div>;
	}

	return (
		<>
			{showUpdateWatchword ? (
				<UpdateWatchword {...updateWatchwordProps} />
			) : (
				<LoginWrapper
					showDesign={true}
					isSubHeader={true}
					isDescription
					isWarningMessage={showForceChangeWatchwordDisclaimer}
					warningText={Constants.DISCALIMER_TEXT}
					description={Constants.FP_SUBHEADER}
					subHeader={Constants?.FP_HEADER}
				>
					<div className={styles?._form_wrapper}>
						<Head>{PageTitles.FORGOT_WATCHWORD}</Head>
						<Form form={form} name="register" onFinish={initiateForgotWatchword} initialValues={{}} scrollToFirstError>
							<Form.Item
								name="username"
								label=""
								className={styles?.username_label}
								rules={[
									{
										required: true,
										message: <ErrorMessage message={Constants.FP_ERR_INVALID_USERNAME} />,
										whitespace: false
									}
								]}
							>
								<Input
									onChange={(e) => {
										onUsernameChange(e?.target?.value);
									}}
									placeholder={Constants.FP_USER_PLACEHOLDER}
									className={`${styles?.username} ${usernameValidCls} ${usernameInvalidCls}`}
									suffix={<Icon height="14px" width="14px" icon="userAvatar" />}
								/>
							</Form.Item>

							<Form.Item>
								<div className={styles?.center}>
									<Button className={styles?.submit_button} disabled={!username || isValidUsername === "invalid"} type="primary" htmlType="submit">
										{Constants.FP_SEND_REQ_BTN}
									</Button>
									<Button className={styles?.goback_button} type="primary" onClick={handleGoBack}>
										{Constants.FP_GOBACK_BTN}
									</Button>
								</div>
							</Form.Item>
						</Form>
					</div>
				</LoginWrapper>
			)}
		</>
	);
};

export default ForgotWatchword;
